import React from 'react'
import rzlfh from '../images/rzlfh-icon.svg'
import lightwork from '../images/lightwork.svg'
import uiux from '../images/uiux.webp'
import frontend from '../images/frontend.webp'
import design from '../images/design.webp'
import { Link } from 'react-router-dom'
import ScrollToTop from '../components/ScrollToTop'
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const Work = () => {

    const { ref, inView } = useInView();
    const animation3up = useAnimation();


    useEffect(() => {
        if (inView) {
            animation3up.start({
                y: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });
        }
        if (!inView) {
            animation3up.start({
                y: 30,
                opacity: 0,
            });
        }
    }, [inView]);

    return (
        <>
            <img src={lightwork} alt="light work" className='absolute top-16 md:top-8 lg:top-0 left-0 right-0 mx-auto -z-10 w-[90%] md:w-[45%]' />

            <main className='px-8 md:px-[7.875em] lg:px-0 grid place-content-center lg:grid-cols-6 text-center lg:text-left py-4 space-y-8 lg:space-y-4'>
                <section className='mt-[14em] lg:col-start-2 lg:col-end-6 lg:grid lg:grid-cols-4'>
                    <motion.h1
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            ease: [0.6, 0.01, -0.05, 0.95],
                            duration: 1,
                            delay: 0.3,
                        }}
                        className='text-[2.3rem] font-syncopate font-bold lg:text-[4.3rem] leading-none lg:col-start-1 lg:col-end-5 lg:w-[50%] '>Work <motion.span
                            initial={{ opacity: 0, y: 60 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                ease: [0.6, 0.01, -0.05, 0.95],
                                duration: 1,
                                delay: 0.8,
                            }}>Portfolio</motion.span>
                    </motion.h1>

                    <div className='mt-[8em] lg:mt-[10em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 lg:flex lg:items-center'>

                        <div className=' lg:col-start-1 lg:col-end-3 text-[1.5rem] lg:text-right font-syncopate font-bold lg:text-[2.5rem] leading-none lg:flex lg:justify-end lg:mr-8'>
                            <motion.h2
                                className='lg:w-[90%] 2xl:w-[50%] mb-8 lg:mb-0'>
                                UI/UX Design
                            </motion.h2>
                        </div>

                        <Link to="/work/uiuxdesign" className='lg:col-start-3 lg:col-end-5 transition-all relative overflow-hidden'>
                            <img src={uiux} alt="uiuix" className='grayscale hover:grayscale-0 w-full max-w-[100%] hover:scale-[1.03] transition-all duration-300' />
                        </Link>
                    </div>

                    <div className='flex flex-col lg:flex-rows mt-[8em] lg:mt-[10em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 lg:flex lg:items-center'>

                        <Link to="/work/frontend" className='lg:col-start-1 lg:col-end-3 transition-all relative overflow-hidden order-2'>
                            <img src={frontend} alt="frontend" className='grayscale hover:grayscale-0 w-full max-w-[100%] hover:scale-[1.03] transition-all duration-300' />
                        </Link>

                        <div className=' lg:col-start-3 lg:order-2 lg:col-end-5 text-[1.5rem] lg:text-left font-syncopate font-bold lg:text-[2.5rem] leading-none lg:flex lg:justify-start lg:ml-8 mb-8 lg:mb-0'>
                            <motion.h2
                                className='lg:w-[90%] 2xl:w-[90%]'>
                                Frontend Development
                            </motion.h2>
                        </div>
                    </div>

                    <div className='mt-[8em] lg:mt-[10em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 lg:flex lg:items-center'>

                        <div className=' lg:col-start-1 lg:col-end-3 text-[1.5rem] lg:text-right font-syncopate font-bold lg:text-[2.5rem] leading-none lg:flex lg:justify-end lg:mr-8'>
                            <motion.h2
                                className='lg:w-[100%] 2xl:w-[100%] mb-8 lg:mb-0'>
                                Graphic Design & Illustration
                            </motion.h2>
                        </div>

                        <Link to="/work/graphicdesign" className='lg:col-start-3 lg:col-end-5 transition-all relative overflow-hidden'>
                            <img src={design} alt="design" className='grayscale hover:grayscale-0 w-full max-w-[100%] hover:scale-[1.03] transition-all duration-300' />
                        </Link>
                    </div>

                </section>

            </main>

            <ScrollToTop />

            <motion.footer ref={ref} animate={animation3up} className=' px-4 md:px-[7.875em] flex items-center justify-between text-center py-8'>
                <img src={rzlfh} alt="rzlfh" className=' hidden md:block animate-spin-slow' />
                <ul className='flex items-center space-x-14 md:space-x-8 text-center  mx-auto md:mx-0'>
                    <li><a href="https://www.instagram.com/rzlfh/" className='underline opacity-70 hover:opacity-100 ' target="_blank">Instagram</a></li>
                    <li><a href="https://www.linkedin.com/in/rizal-fahadian-281b571b1/" className='underline opacity-70 hover:opacity-100' target="_blank">LinkedIn</a></li>
                    <li><a href="https://github.com/rzlfhh" className='underline opacity-70 hover:opacity-100' target="_blank">Github</a></li>
                </ul>
            </motion.footer>


        </>
    )
}

export default Work
